module.exports = "/images/Guatemala.png?24735100d04f35864db5b514f3da9ab9";